// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","ideaMiniCard":"oW8GLg0NuRBaCX9w95XTB","assetSymbol":"p46R-PP9kj5DW2YM0a9R7"};